module.exports = __webpack_public_path__ + "img/high-five-hands-drawing.b235d9ac.png";